'use client';

import { I18nextProvider } from 'react-i18next';
import { i18n } from '@ninjacart/nc-nk-store';

export function TranslationsProvider({
  children,
  locale,
  namespaces,
}: {
  children: React.ReactNode;
  locale: string;
  namespaces: Record<string, any>;
}) {
  Object.entries(namespaces).forEach(([ns, resources]) => {
    i18n.addResourceBundle(locale, ns, resources, true, true);
  });

  i18n.changeLanguage(locale);

  // console.log("I18n config => ", i18n.isInitialized, i18n.language, i18n.languages, i18n.t);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
